import React, { PropsWithChildren } from 'react';
import { I18nProvider } from '../../../shared/i18n';

export const TranslationProvider = ({
    children,
}: PropsWithChildren<unknown>) => <I18nProvider>{children}</I18nProvider>;
